/**
* Before and After Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Before and After Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'before-and-after-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.before-after-slider-outer' ).slick( {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        appendArrows: $( '.before-after-nav-wrapper' ),
        prevArrow: '<button type="button" class="hover:underline"><svg class="icon icon-basic-left-arrow mb-1 mr-3"><use xlink:href="#icon-basic-left-arrow"></use></svg>Previous case</button>',
        nextArrow: '<button type="button" class="hover:underline">Next case<svg class="icon ml-3 mb-1 icon-basic-right-arrow"><use xlink:href="#icon-basic-right-arrow"></use></svg></button>',
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'before-and-after-slider', COMPONENT );
} )( app );
